<template>
<div style="height: 100%">
    <div id="evolve">Evolve</div>
    <div class="row" id="content">
        <div class="col d-flex flex-row align-items-center">
            <div id="form">
                <form @submit.prevent="changepassword">
                    <div class="row">
                        <h1 id="title">Change Password</h1>
                    </div>
                    <div class="form-group">
                        <input type="password" name="newpassword" id="newpassword" placeholder="NEW PASSWORD" v-model="newpassword" class="form-control"/>
                    </div>
                    <div class="form-group">
                        <input type="password" name="confirmpassword" id="confirmpassword" placeholder="CONFIRM PASSWORD" v-model="confirmpassword" class="form-control"/>
                    </div>
                    <div class="d-flex flex-column" >
                    <div> 
                        <p v-if="feedback" class="feedback">{{feedback}}</p>
                        <button type="submit" class="btn btn-primary">Save</button>
                    </div>
                    </div>
                </form> 
            </div>
        </div>
    </div>
</div>
</template>
<script>
import firebase from '@/firebase/init'
export default {
    name: 'ChangePassword',
    props: ['mode', 'oobCode', 'lang'],
    data(){
        return{
            newpassword: null,
            confirmpassword: null,
            feedback: null
        }
    },
    methods: {
        changepassword(){
            var thisRef = this
            if(this.newpassword && this.confirmpassword){
                if(this.newpassword == this.confirmpassword){
                    var auth = firebase.auth()
                    var accountEmail
                        auth.verifyPasswordResetCode(this.oobCode).then(function(email) {
                            var accountEmail = email
                            auth.confirmPasswordReset(thisRef.oobCode, thisRef.newpassword).then(function(resp) {
                                thisRef.$router.push({name: 'Login'})
                            }).catch(function(error) {
                                thisRef.feedback = error.message
                            });
                        }).catch(function(error) {
                           thisRef.feedback = error.message
                        });
                }
                else{
                    this.feedback = "Password doesn't match"
                }
            }
            else{
                this.feedback = "You must enter both fields"
            }
        }
    },
    beforeCreate: function() {
            document.body.className = 'signup'
            this.$parent.showNavbar = false        
    }
}
</script>
<style>
.feedback{
    color: red;
}
#evolve{
    font-family: GothamRndSSm-Light;
    font-size: 22px;
    color: black;
    margin: 0 0 0 5em;
    height: 5%;
    text-align: start;
    bottom: 0;
    text-anchor: end;
    padding-top: 3em;
}
.form-control{
    border-color: black;
    height: 3.5em;
    margin-top: 1.5em;
    padding-left: 1.5em;
    border-radius: 0.5em;
    line-height: normal;
    line-height: 32px;
}
.btn{
    font-size: 0.7em !important;
    height: 5em;
    width: 50%;
    right: 0;
    margin-top: 1.5em;
    float: left;
    background-color: #5D38DB;
    border-radius: 0.5em;
    line-height: inherit;
}
::placeholder {
  color: black !important;
  font-family: GothamRndSSm-Book;
  font-size: 10px !important;

}
#form{
    width: 30em;
    margin-left: 10em;
}
#title{
    color: black;
    font-size: 40px;
    font-family: GothamRndSSm-Light;
}
p{
    margin-top: 1.5em;
    margin-bottom: 3em;
}
.row h1{
    margin-left: 0.5em;
    margin-bottom: 0.8em;
}
#content{
    height: 90%;
    margin-left: 0;
    margin-right: 0;
}
@media (max-width: 700px) {
    #evolve{
        margin-left: 3em;
    }
    #form{
        margin-left: 2em;
    }
}
@media (max-width: 600px) {
    #evolve{
        padding-top: 0;
        margin-top: 2em;
        margin-left: 1em;
    }
    #form{
        margin-left: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ChangePassword.vue